<template>
  <div class="terms-of-use-modal">
    <main :style="{ color: $theme.darkTheme ? '#fff' : '#333' }">
      <div class="row" style="margin-left: 0">
        <div class="col">
          <div class="terms-title title">
            <p>Termos de uso do curso</p>
          </div>
        </div>
      </div>

      <div class="row update-notice" v-if="isUpdate" style="margin-bottom: 10px">
        <div class="col">
          <p class="update-text">Termos atualizados em {{ updatedAt | formatDate }}</p>
        </div>
      </div>

      <div class="row terms-content" style="margin-bottom: 20px">
        <div class="col s12">
          <div class="terms-scroll">
            <div v-html="termContent" />
          </div>
        </div>
      </div>

      <div class="terms-footer row s12" style="margin-bottom: 0">
        <div class="col">
          <button class="btn waves-effect waves-light btn--reject" @click="rejectTerms" :disabled="loading">
            Recusar
          </button>

          <button
            class="btn waves-effect waves-light"
            :disabled="loading"
            @click="acceptTerms"
          >
            {{ loading ? "Processando..." : "Aceitar" }}
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { formatDate } from "@/filters/formatDate";

export default {
  name: "TermsOfUseModal",
  props: {
    term: Object,
    isUpdate: Boolean,
    updatedAt: String,
    acceptHandler: Function,
    rejectHandler: Function,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    termContent() {
      return this.term?.content || "";
    },
  },
  methods: {
    async acceptTerms() {
      if (this.loading) return;
      this.loading = true;
      try {
        await this.acceptHandler();
      } finally {
        this.loading = false;
      }
    },
    async rejectTerms() {
      if (this.loading) return;
      this.loading = true;
      try {
        await this.rejectHandler();
      } finally {
        this.loading = false;
      }
    },
  },
  filters: {
    formatDate(date) {
      if (!date) return "";
      return formatDate(new Date(date));
    },
  },
};
</script>

<style lang="scss" scoped>
.terms-of-use-modal {
  padding: 18px 12px;
  max-height: 100vh;
  display: flex;
  flex-direction: column;

  main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .title {
    font-family: robotobold, sans-serif;
    font-size: 1.2rem;

    p {
      margin: 0;
    }
  }

  .update-notice {
    .update-text {
      color: #ff9800;
      font-weight: 500;
      font-size: 0.95rem;
      margin: 0;
    }
  }

  .terms-content {
    flex: 1;
    overflow: hidden;
    margin: 0 0 20px 0;

    .terms-scroll {
      max-height: 60vh;
      overflow-y: auto;
      padding-inline: 15px;
      border: 1px solid rgba(128, 128, 128, 0.3);
      border-radius: 10px;
      min-height: 200px;
      font-family: Roboto, sans-serif;
    }
  }

  .terms-footer {
    width: 100%;

    .col {
      width: 100%;

      display: flex;
      gap: 1rem;

      button {
        flex-grow: 2;

        &.btn--reject {
          flex-grow: 1;
        }
      }
    }
  }

  .btn {
    border-radius: 0.5rem;
    background-color: #9747ff;
  }

  .btn--reject {
    filter: grayscale(1);
  }

  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>

<style>
.terms-content .terms-scroll * {
  all: revert;
  line-height: 1.15;
}
</style>
